import { render, staticRenderFns } from "./meal-list.vue?vue&type=template&id=cf0e201c&"
import script from "./meal-list.vue?vue&type=script&lang=js&"
export * from "./meal-list.vue?vue&type=script&lang=js&"
import style0 from "./meal-list.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports